import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.keys.js";
import { defineComponent, ref, reactive } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Head from "@/components/Head/index.vue";
import { saveAs } from "@/hooks/downUrl";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import MeetingDetail from "./components/Detail.vue";
import { validStEnpty } from "@/hooks/validate";
export default defineComponent({
  name: "MeetingSignUp",
  components: {
    Head: Head,
    MeetingDetail: MeetingDetail
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var router = useRouter();
    var write = ref(false);
    var detail = reactive({
      status: 0,
      attendance: 0
    });
    var attentionPerson = ref({});
    var detailShow = ref(false);
    var showDetail = ref(false);
    var experience = reactive({
      offlineMeetingId: "",
      tips: "",
      attenId: 0
    });
    var showAttachment = ref("暂无附件");
    var attachmentId = ref(0);
    var recoder = ref([{
      title: "签到",
      num: "registered"
    }, {
      title: "迟到",
      num: "late"
    }, {
      title: "请假",
      num: "leave"
    }, {
      title: "旷会",
      num: "not_join"
    }, {
      title: "全部人数",
      num: "all"
    }]);
    var attentDetail = reactive({
      tips: "",
      punch: 0
    });
    var takingLeave = ref(0);
    var id = route.query.id;
    experience.offlineMeetingId = String(id);

    function getMeetingDetail() {
      return _getMeetingDetail.apply(this, arguments);
    } //当前用户某会议的请假、补会数据


    function _getMeetingDetail() {
      _getMeetingDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data, _i, _Object$keys, v;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMeetingDetail"](id);

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;

                for (_i = 0, _Object$keys = Object.keys(data); _i < _Object$keys.length; _i++) {
                  v = _Object$keys[_i];
                  detail[v] = data[v];
                }

                console.log('detail: ', detail);
                detailShow.value = true;

                if (data.attachment || data.attachment === 0) {
                  getFileNameById(data.attachment);
                } else {
                  showAttachment.value = "暂无附件";
                }

                showDetail.value = true;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getMeetingDetail.apply(this, arguments);
    }

    function getMeetingPunchMessage() {
      return _getMeetingPunchMessage.apply(this, arguments);
    }

    function _getMeetingPunchMessage() {
      _getMeetingPunchMessage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var studyData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMeetingPunchMessage"]({
                  meetingId: id,
                  style: 1
                });

              case 2:
                studyData = _context2.sent;

                if (studyData.data && studyData.data.status == 2 && detail.status == 5 && attentDetail.tips == "" && attentDetail.punch == 7) {
                  takingLeave.value = 3; //提交补学申请了，显示填写心得
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getMeetingPunchMessage.apply(this, arguments);
    }

    function submit() {
      return _submit.apply(this, arguments);
    } //根据附件id获取附件名


    function _submit() {
      _submit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (validStEnpty(experience.tips)) {
                  _context3.next = 3;
                  break;
                }

                ElMessage.error("\u8BF7\u5148\u8F93\u5165");
                return _context3.abrupt("return", false);

              case 3:
                _context3.next = 5;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["writeExperience"](experience);

              case 5:
                data = _context3.sent;

                if (data.code == 0) {
                  getMeetingAttend();
                }

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _submit.apply(this, arguments);
    }

    function getFileNameById(_x) {
      return _getFileNameById.apply(this, arguments);
    } //下载附件


    function _getFileNameById() {
      _getFileNameById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
        var data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getFileNameById"](id);

              case 2:
                data = _context4.sent;
                showAttachment.value = data.data.realName;
                attachmentId.value = data.data.attachmentId;

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _getFileNameById.apply(this, arguments);
    }

    function downFile() {
      saveAs(attachmentId.value);
    } //获取考勤id


    function getMeetingAttend() {
      return _getMeetingAttend.apply(this, arguments);
    } //获取该会议的考勤情况


    function _getMeetingAttend() {
      _getMeetingAttend = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var data, _i2, _Object$keys2, v;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMeetingAttend"]({
                  offlineMeetingId: id
                });

              case 2:
                data = _context5.sent;

                if (data.code == 0) {
                  experience.attenId = data.data.attenId;

                  for (_i2 = 0, _Object$keys2 = Object.keys(data.data); _i2 < _Object$keys2.length; _i2++) {
                    v = _Object$keys2[_i2];
                    attentDetail[v] = data.data[v];
                  }
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _getMeetingAttend.apply(this, arguments);
    }

    function getMeetingAttendPerson() {
      return _getMeetingAttendPerson.apply(this, arguments);
    } //查看


    function _getMeetingAttendPerson() {
      _getMeetingAttendPerson = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var data;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMeetingAttendPerson"]({
                  offlineMeetingId: id
                });

              case 2:
                data = _context6.sent;

                if (data.code == 0) {
                  attentionPerson.value = data.data;
                }

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _getMeetingAttendPerson.apply(this, arguments);
    }

    function toWatch(_x2) {
      return _toWatch.apply(this, arguments);
    }

    function _toWatch() {
      _toWatch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(res) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                router.push({
                  path: "/personal/meetingAttendance",
                  query: {
                    id: id,
                    title: res
                  }
                });

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
      return _toWatch.apply(this, arguments);
    }

    getMeetingAttend();
    getMeetingDetail();
    getMeetingAttendPerson();
    return {
      detail: detail,
      showDetail: showDetail,
      write: write,
      detailShow: detailShow,
      submit: submit,
      getMeetingAttend: getMeetingAttend,
      getMeetingAttendPerson: getMeetingAttendPerson,
      toWatch: toWatch,
      getFileNameById: getFileNameById,
      downFile: downFile,
      getMeetingPunchMessage: getMeetingPunchMessage,
      attachmentId: attachmentId,
      showAttachment: showAttachment,
      experience: experience,
      attentDetail: attentDetail,
      attentionPerson: attentionPerson,
      recoder: recoder,
      takingLeave: takingLeave
    };
  }
});